import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import InstallPrompt from "@/components/InstallPrompt";

import Login from "@/pages/Login";
import SuperAdminDashboard from "@/pages/superadmin/Dashboard";
import Estates from "@/pages/superadmin/Estates";
import Managers from "@/pages/superadmin/Managers";
import Reports from "@/pages/superadmin/Reports";
import ManagerDashboard from "@/pages/manager/Dashboard";
import Units from "@/pages/manager/Units";
import Residents from "@/pages/manager/Residents";
import ManagerTickets from "@/pages/manager/Tickets";
import ResidentDashboard from "@/pages/resident/Dashboard";
import ResidentTickets from "@/pages/resident/Tickets";
import NewTicket from "@/pages/resident/NewTicket";
import TicketDetail from "@/pages/TicketDetail";

function RoleHome() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  const home =
    user.role === "super_admin" ? "/a/dashboard" :
    user.role === "estate_manager" ? "/m/dashboard" : "/r/dashboard";
  return <Navigate to={home} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors toastOptions={{ className: "!max-w-[92vw]" }} />
          <InstallPrompt />
          <Routes>
            <Route path="/" element={<RoleHome />} />
            <Route path="/login" element={<Login />} />

            {/* Super Admin */}
            <Route path="/a/dashboard" element={<ProtectedRoute roles={["super_admin"]}><SuperAdminDashboard /></ProtectedRoute>} />
            <Route path="/a/estates" element={<ProtectedRoute roles={["super_admin"]}><Estates /></ProtectedRoute>} />
            <Route path="/a/managers" element={<ProtectedRoute roles={["super_admin"]}><Managers /></ProtectedRoute>} />
            <Route path="/a/reports" element={<ProtectedRoute roles={["super_admin"]}><Reports /></ProtectedRoute>} />

            {/* Estate Manager */}
            <Route path="/m/dashboard" element={<ProtectedRoute roles={["estate_manager"]}><ManagerDashboard /></ProtectedRoute>} />
            <Route path="/m/units" element={<ProtectedRoute roles={["estate_manager"]}><Units /></ProtectedRoute>} />
            <Route path="/m/residents" element={<ProtectedRoute roles={["estate_manager"]}><Residents /></ProtectedRoute>} />
            <Route path="/m/tickets" element={<ProtectedRoute roles={["estate_manager"]}><ManagerTickets /></ProtectedRoute>} />

            {/* Resident */}
            <Route path="/r/dashboard" element={<ProtectedRoute roles={["resident"]}><ResidentDashboard /></ProtectedRoute>} />
            <Route path="/r/tickets" element={<ProtectedRoute roles={["resident"]}><ResidentTickets /></ProtectedRoute>} />
            <Route path="/r/tickets/new" element={<ProtectedRoute roles={["resident"]}><NewTicket /></ProtectedRoute>} />

            {/* Shared */}
            <Route path="/tickets/:id" element={<ProtectedRoute><TicketDetail /></ProtectedRoute>} />

            <Route path="*" element={<RoleHome />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
